import { Configuration, ApiResponseOfVideoAssetResponse, VideoAssetBody, VideoAssetsApi } from '../../../API';
import { AxiosResponse } from 'axios';
export class VideoAssetsAPI {
  api: VideoAssetsApi;

  getPaginated!: typeof VideoAssetsApi.prototype.getPaginated;
  getByFilePath!: typeof VideoAssetsApi.prototype.getByFilePath;
  getById!: typeof VideoAssetsApi.prototype.getById;
  update!: typeof VideoAssetsApi.prototype.update;
  remove!: typeof VideoAssetsApi.prototype.remove;

  constructor(config: Configuration) {
    const api = new VideoAssetsApi(config);
    Object.assign(this, api);

    this.api = api;

    this.getPaginated = api.getPaginated;
    this.getByFilePath = api.getByFilePath;
    this.getById = api.getById;
    this.remove = api.remove;
    this.update = api.update;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  create(asset: VideoAssetBody, file: File): Promise<AxiosResponse<ApiResponseOfVideoAssetResponse, any>> {
    return this.api.create(asset.assetId, asset.assetName, asset.assetType, asset.videoAssetRole, file);
  }
}
